import { ContractStatus } from "../types";

const STYLES: Record<ContractStatus | "PENDING", string> = {
  ACTIVE: "bg-[#E2F4EB] text-[#0A8F4F]",
  INACTIVE: "bg-[#FEE4E2] text-[#C8311C]",
  PENDING: "bg-[#FFF4D6] text-[#B68A0E]",
};

export function StatusBadge({
  status,
}: {
  status: ContractStatus | "PENDING";
}) {
  return (
    <span
      className={`text-[10px] font-semibold tracking-wide px-3 py-1 rounded-full ${STYLES[status]}`}
    >
      {status}
    </span>
  );
}

export default StatusBadge;
